var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallLetterA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 141,
    viewBox: "0 0 113 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.0326 5.13971L86.6118 15.8619L32.0221 136.02L2.33766 119.957L60.0326 5.13971Z",
    fill: "#2B1B57",
    fillOpacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5919 15.8721L99.6917 13.2251L113 129.204H92.7052L84.4959 110.107L71.3088 111.771L62.6629 133.553L32.0093 136.049L86.5919 15.8721Z",
    fill: "url(#paint0_linear_9_71)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3334 109.318L85.7389 107.935L84.2456 108.123L71.0584 109.787L69.8859 109.935L69.4499 111.033L61.2623 131.66L35.2366 133.779L87.9901 17.63L97.9531 15.6168L110.757 127.204H94.0224L86.3334 109.318Z",
    stroke: "#2B1B57",
    strokeOpacity: 0.95,
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.304 4.9057L99.6044 13.1494L86.5919 15.8721L60.0429 5.13259L80.304 4.9057Z",
    fill: "#1166E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0434 6.07666L80.1047 5.90799L96.2902 12.8212L86.6849 14.831L65.0434 6.07666Z",
    stroke: "#2B1B57",
    strokeOpacity: 0.95,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4959 110.107L92.7052 129.166L82.138 121.603L78.3827 110.864L84.4959 110.107Z",
    fill: "#2B1B57",
    fillOpacity: 0.95
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5321 79.8775C81.0024 79.0704 82.2242 79.2915 82.3818 80.2122L84.8196 94.4469C84.9172 95.0169 84.5125 95.5506 83.9373 95.6104L72.5148 96.7966C71.7009 96.8811 71.1355 96.0056 71.5475 95.2985L80.5321 79.8775Z",
    fill: "#2B1B57",
    fillOpacity: 0.95
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_71",
    x1: 72.5046,
    y1: 13.2251,
    x2: 72.5046,
    y2: 136.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54B0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E719A1",
    stopOpacity: 0.38
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLetterA);
export default __webpack_public_path__ + "static/media/small_letterA.ec72d6d619ef857afb31e6e3763b083a.svg";
export { ForwardRef as ReactComponent };